import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { Translatable } from "app/pages/sales-intelligence/types";
import type { ReactNode } from "react";
import NoContentView from "../common/NoContentView/NoContentView";
import { StyledList, StyledListItem, StyledSubTitle } from "../styles";

const listItems: readonly Translatable[] = [
    { key: "si.pages.home.card.lists.no-content.item-1.text" },
    { key: "si.pages.home.card.lists.no-content.item-2.text" },
    { key: "si.pages.home.card.lists.no-content.item-3.text" },
];

type Props = {
    actions: NonNullable<ReactNode>;
};

const EmptyListsView = ({ actions }: Props) => {
    return (
        <NoContentView actions={actions}>
            <I18n
                translatable={{ key: "si.pages.home.card.lists.no-content.title" }}
                element={StyledSubTitle}
            />

            <StyledList>
                {listItems.map((item, index) => (
                    <I18n
                        key={index}
                        translatable={item}
                        element={StyledListItem}
                    />
                ))}
            </StyledList>
        </NoContentView>
    );
};

export default EmptyListsView;
